var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QRCodeScanner',{attrs:{"state":_vm.state,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }